<template>
  <v-container fluid class="pa-0" style="margin-top: 2vh;">
    <v-data-table
      :headers="headers"
      :items="filteredList"
      :items-per-page="10"
      class="elevation-1"
      :options="stateOptions"
      @update:options="onUpdate"
      :search="search"
      :custom-filter="customFilter"
      @click:row="onUserClick"
    >
      <template v-slot:top>
        <v-row
          class="mb-0"
          style="border-bottom: 1px solid rgba(255, 255, 255, 0.12)"
        >
          <v-col class="d-flex align-center">
            <v-dialog persistent v-model="dialog" max-width="700px">
              <!-- <template v-if="isAllowedUserActions" v-slot:activator="{ on }">
              <v-btn class="mb-2" v-on="on">Create User</v-btn>
            </template> -->
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="16" sm="6" md="8">
                        <v-text-field
                          v-model="editedItem.firstName"
                          label="First Name"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="16" sm="6" md="8">
                        <v-text-field
                          v-model="editedItem.lastName"
                          label="Last Name"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="16" sm="6" md="8">
                        <v-text-field
                          v-model="editedItem.username"
                          label="Username"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="16" sm="6" md="8">
                        <v-select
                          :items="$store.state.UserStore.userRoles"
                          v-model="editedItem.role"
                          label="User Role"
                          required
                          outlined
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog
              @click:outside="cancelInvite"
              v-model="invite"
              height="350"
              max-width="500px"
            >
              <template v-if="isAllowedUserActions" v-slot:activator="{ on }">
                <v-btn class="ml-4" small v-on="on">Invite User</v-btn>
              </template>
              <v-card>
                <v-toolbar flat color="primary" dark>
                  <v-card-title class="pa-0">
                    <span class="headline font-weight-medium">Invite User</span>
                  </v-card-title>
                </v-toolbar>
                <v-card-text class="pa-4 pt-0">
                  <v-window v-model="invitationStep">
                    <v-window-item :value="1">
                      <v-text-field
                        v-model="inviteEmail"
                        :error-messages="emailErrors"
                        required
                        @input="$v.inviteEmail.$touch()"
                        @blur="$v.inviteEmail.$touch()"
                        label="Email"
                        class="mb-2"
                      ></v-text-field>
                      <v-row class="pb-10">
                        <v-col cols="16" sm="6" md="8">
                          <v-select
                            :items="$store.state.UserStore.userRoles"
                            v-model="inviteRole"
                            label="User Role"
                            item-text="name"
                            item-value="role"
                            required
                            outlined
                          ></v-select>
                        </v-col>
                      </v-row>
                    </v-window-item>
                    <v-window-item :value="2">
                      <v-card-subtitle
                        class="
                        white--text
                        pa-0
                        mt-4
                        mb-4
                        text-h6
                        font-weight-regular
                      "
                      >
                        We invited
                        <span class="font-weight-bold">{{ inviteEmail }}</span>
                        to your project!
                      </v-card-subtitle>
                      <v-card-text class="pa-0 mb-4">
                        They will receive an invitation email shortly where
                        there will be a link to join the project.
                      </v-card-text>
                      <v-card-text class="pa-0 pb-12">
                        If the user does not receive the invitation email, you
                        can resend the email from users list in the project.
                      </v-card-text>
                    </v-window-item>
                  </v-window>
                </v-card-text>

                <v-card-actions v-if="invitationStep === 1" class="pa-4">
                  <v-spacer></v-spacer>
                  <v-btn color="darken-1" @click="cancelInvite">Cancel</v-btn>
                  <v-btn
                    :disabled="!inviteValidation"
                    color="primary darken-1"
                    @click="sendInvite"
                    >OK</v-btn
                  >
                </v-card-actions>
                <v-card-actions v-if="invitationStep === 2" class="pa-4">
                  <v-spacer></v-spacer>
                  <v-btn color="primary darken-1" @click="cancelInvite"
                    >OK</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col cols="2" sm="2" md="2">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              hide-details
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="2" sm="2" md="2">
            <v-select
              :items="userRoles"
              v-model="selectedUserRoleFilter"
              label="Role"
              item-text="name"
              item-value="role"
              @change="forceSearchUpdate()"
              outlined
              dense
              class="mr-4"
              :hide-details="true"
            ></v-select>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.username="{ item }">
        <tr>
          <span
            :class="{
              disabled:
                item.statusOnProject && item.statusOnProject === 'invited'
            }"
            >{{ item.username }}</span
          >
        </tr>
      </template>
      <template v-slot:item.firstName="{ item }">
        <tr>
          <span
            :class="{
              disabled:
                item.statusOnProject && item.statusOnProject === 'invited'
            }"
            >{{ item.firstName }}</span
          >
        </tr>
      </template>
      <template v-slot:item.lastName="{ item }">
        <span
          :class="{
            disabled: item.statusOnProject && item.statusOnProject === 'invited'
          }"
          >{{ item.lastName }}</span
        >
      </template>
      <template v-slot:item.role="{ item }">
        <span
          :class="{
            disabled: item.statusOnProject && item.statusOnProject === 'invited'
          }"
          >{{ item.roleOnProjectName }}</span
        >
      </template>
      <template v-slot:item.action="{ item }">
        <div class="action-wrapper">
          <v-btn
            @click="reinviteUser(item)"
            x-small
            color="#4CAF50"
            outlined
            v-if="item.statusOnProject && item.statusOnProject === 'invited'"
          >
            resend invite
          </v-btn>
          <template
            v-if="
              item.role !== 'super_admin' &&
                item.roleOnProject !== 'sales_agent' &&
                item.roleOnProject !== 'user'
            "
          >
            <img
              v-if="item.roleOnProject === 'project_admin'"
              class="icon"
              :class="{
                disabled:
                  item.statusOnProject && item.statusOnProject === 'invited'
              }"
              :src="require('@/assets/crown-active.png')"
              alt="crown image"
            />
            <img
              v-else
              @click="changeAdminDialog(item)"
              class="icon"
              :class="{
                disabled:
                  item.statusOnProject && item.statusOnProject === 'invited'
              }"
              :src="require('@/assets/crown.png')"
              alt="crown image"
            />
          </template>
          <img
            v-if="item.role !== 'super_admin'"
            @click="deleteItemModal(item)"
            class="icon"
            :src="require('@/assets/close.png')"
            alt="delete"
          />
        </div>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
export default {
  name: 'UserList',
  props: {
    userList: {
      type: Array,
      required: true,
      default: function() {
        return []
      }
    }
  },
  mixins: [validationMixin],
  data: function() {
    return {
      invitationStep: 1,
      headers: [
        { text: 'Username', align: 'left', sortable: true, value: 'username' },
        {
          text: 'First Name',
          align: 'left',
          sortable: true,
          value: 'firstName'
        },
        { text: 'Last Name', align: 'left', sortable: true, value: 'lastName' },
        { text: 'User Role', align: 'left', sortable: true, value: 'role' }
      ],
      editedIndex: -1,
      editedItem: {
        firstName: '',
        lastName: '',
        email: '',
        username: '',
        role: ''
      },
      defaultItem: {
        firstName: '',
        lastName: '',
        email: '',
        username: '',
        role: 'user'
      },
      invite: false,
      inviteEmail: null,
      inviteRole: null,
      dialog: false,
      mounted: false,
      stateOptions: {},
      search: '',
      isAllowedUserActions: true,
      selectedUserRoleFilter: '',
      userRoles: ['all']
    }
  },
  computed: {
    ...mapState('ProjectStore', ['selectedProject']),
    formTitle() {
      return this.editedIndex === -1 ? 'Create User' : 'Edit User'
    },
    filteredList() {
      let users = this.userList.filter(this.filterRole)
      users = users.filter(
        el => el.email !== process.env.VUE_APP_ANON_USER_NAME
      )
      return users
    },
    emailErrors() {
      const errors = []
      if (!this.$v.inviteEmail.$dirty) return errors
      !this.$v.inviteEmail.email && errors.push('Must be valid e-mail')
      !this.$v.inviteEmail.required && errors.push('E-mail is required')
      return errors
    },
    inviteValidation() {
      return !this.$v.inviteEmail.$invalid && this.inviteRole
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  },
  created: async function() {
    this.userRoles = this.userRoles.concat(
      this.$store.state.UserStore.allUserRoles
    )
    // users on project

    await this.checkIfUserCanEdit()
  },
  methods: {
    async checkIfUserCanEdit() {
      this.isAllowedUserActions = await this.$store.dispatch(
        'UserStore/isAllowed',
        {
          resourceName: 'users-on-project',
          permission: 'edit',
          projectId: parseInt(this.$route.params.projectId)
        }
      )
      if (this.isAllowedUserActions) {
        this.headers.push({
          text: 'Actions',
          value: 'action',
          sortable: false,
          align: 'right'
        })
      }
    },
    changeAdminDialog(item) {
      let text =
        this.$store.state.UserStore.userRole[0] === 'super_admin'
          ? ''
          : 'Your role will become Project Editor. You will be able to leave the project. Project admin will be able to remove you from the project.'
      this.$store.dispatch('DialogStore/open', {
        title: 'Promote to Project Admin',
        header: true,
        subtitle:
          item.email + ' will become Project Admin?<br><br>Are you sure?',
        text: text,
        okText: 'Ok',
        ok: () => {
          this.changeAdmin(item)
        },
        cancelText: 'Cancel'
      })
    },
    async changeAdmin(item) {
      let params = {
        newAdminId: item.id,
        projectId: parseInt(this.$route.params.projectId)
      }
      await this.$store
        .dispatch('UserStore/changeAdmin', params)
        .then(res => {
          this.$store.dispatch(
            'ProjectStore/getUsersOnProject',
            this.$route.params.projectId
          )
        })
        .then(() => {
          if (this.isAllowedUserActions) {
            this.headers.pop()
          }
          this.checkIfUserCanEdit()
        })
        .catch(e => {
          return e
        })
    },
    reinviteUser(item) {
      this.inviteEmail = item.email
      this.inviteRole = item.roleOnProject
      this.sendInvite()
    },
    cancelInvite() {
      this.inviteEmail = null
      this.inviteRole = null
      this.invite = false
      this.invitationStep = 1
    },
    async sendInvite() {
      if (this.$v.inviteEmail.$invalid || !this.inviteRole) {
        return
      } else {
        let params = {
          email: this.inviteEmail,
          username: this.inviteEmail,
          role: this.inviteRole
        }
        let res = await this.$store
          .dispatch('UserStore/createUser', {
            userData: params,
            projectId: parseInt(this.$route.params.projectId)
          })
          .catch(e => {
            return e
          })
        if (res instanceof Error) {
          return
        }
        await this.$store.dispatch(
          'ProjectStore/getUsersOnProject',
          this.$route.params.projectId
        )
        this.invitationStep = 2
        this.invite = true
      }
    },
    onUpdate(value) {
      if (this.mounted) {
        localStorage.poiListOptions = JSON.stringify(value)
      }
    },
    customFilter(value, search, item) {
      return new RegExp(search, 'i').test(item.username)
    },
    forceSearchUpdate() {},
    filterRole(user) {
      if (
        this.selectedUserRoleFilter === '' ||
        this.selectedUserRoleFilter === 'all' ||
        user.role == this.selectedUserRoleFilter
      ) {
        return true
      }
      return false
    },
    async onUserClick(user) {},
    editItem(item) {
      this.editedIndex = this.userList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItemModal(item) {
      this.$store.dispatch('DialogStore/open', {
        title: 'Remove user from project',
        header: true,
        subtitle:
          'User ' +
          item.email +
          ' will be removed from this project<br><br>Are you sure?',
        okText: 'Ok',
        ok: () => {
          this.deleteItem(item)
        },
        cancelText: 'Cancel'
      })
    },
    async deleteItem(item) {
      let data = {
        userId: item.id,
        projectId: parseInt(this.$route.params.projectId)
      }
      await this.$store.dispatch('UserStore/removeUserFromProject', data)
      await this.$store.dispatch(
        'ProjectStore/getUsersOnProject',
        this.$route.params.projectId
      )
      // this.$confirm({
      //   title: 'Remove user from this project?',
      //   text: 'Are you sure?',
      //   acceptText: 'REMOVE',
      //   cancelText: 'CANCEL'
      // })
      //   .then(y => {
      //     this.$store.dispatch('UserStore/deleteUser', item.id)
      //       .then(
      //         () => {
      //           const index = this.userList.indexOf(item)
      //           this.userList.splice(index, 1)
      //           //this.$router.go(-1)
      //           this.$emit('deleted')
      //         },
      //         err => {
      //           this.$store.dispatch(
      //             'NotificationStore/add',
      //             {
      //               type: 'error',
      //               message:
      //                 'Cannot delete user.'
      //             },
      //             { root: true }
      //           )
      //         }
      //       )
      //   })
      //   .catch(n => {
      //     console.log('NO')
      //   })
    },

    close() {
      this.dialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      // if (!this.hasParentProp) {
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
      // }
    },

    async save() {
      if (
        this.editedItem.username == '' ||
        this.editedItem.firstName == 0 ||
        this.editedItem.lastName == 0
      ) {
        this.$store.dispatch(
          'NotificationStore/add',
          { type: 'error', message: `All fields are required.` },
          { root: true }
        )
      } else if (this.editedIndex > -1) {
        //UPDATE
        await this.$store.dispatch('UserStore/updateUser', this.editedItem)
        await this.$store.dispatch(
          'ProjectStore/getUsersOnProject',
          this.$route.params.projectId
        )
      } else {
        //CREATE
        this.editedItem.password = '12345'
        await this.$store.dispatch('UserStore/createUser', {
          userData: this.editedItem,
          projectId: parseInt(this.$route.params.projectId)
        })
        await this.$store.dispatch(
          'ProjectStore/getUsersOnProject',
          this.$route.params.projectId
        )
      }
      this.close()
    }
  },
  validations: {
    inviteEmail: {
      email,
      required
    }
  }
}
</script>

<style lang="scss" scoped>
.text-left {
  .disabled {
    color: #737373;
  }
}
.icon {
  margin-left: 20px;
  cursor: pointer;
}
.icon.disabled {
  opacity: 0.3;
  pointer-events: none;
}
.action-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
